import * as Yup from 'yup';

export const adminUserSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('requiredFirstName'),
  lastName: Yup.string(),
  email: Yup.string()
    .email('invalidEmailError'),
  phone: Yup.string().matches(
    /^$|^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
    'invalidPhoneNumber',
  ),
});
